<template>
  <div class="blending_container">
    <ul class="edge_ul">
      <li class="edge_li">
        <span class="blending-title">{{$t('T_EDGE_BLENDING_CHOOSE_THE_PROJECTOR_MSG')}}</span>
        <SearchProjector :shape = 'shapeInput'></SearchProjector>
      </li>
      <div class="seach-content">
        <el-row>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <SearchProjectorResult></SearchProjectorResult>
          </el-col>
          <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
            <ComparisonLens></ComparisonLens>
          </el-col>
          <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
              <UserSaveHistory></UserSaveHistory>
            </el-col>
        </el-row>
      </div>

      <li class="edge_li">
        <span class="edge-title">{{$t('T_CHOOSE_THE_POSITION_OF_PROJECTOR')}}</span>
        <span class="edge-select">
          <el-select v-model="position">
            <el-option v-for='item in positionOptions' :key='item.value' :label='$t(item.label)' :value='item.value'>
            </el-option>
          </el-select>
        </span>
      </li>

      <li class="edge_li">
        <span class="edge-title">{{$t('T_EDGE_BLENDING_CHOOSE_THE_SCREEN_SHAPE')}}</span>
        <span class="edge-select">
          <el-select v-model='shapeInput'>
            <el-option v-for='item in shapeOptions' :key='item.value' :disabled='item.disabled' :label='$t(item.label)' :value='item.value'>
            </el-option>
          </el-select>
        </span>
      </li>

      <li class="edge_li" v-if="shapeInput==='2'">
        <span class="edge-title">{{$t('T_EDGE_BLENDING_INPUT_THE_SCREEN_SIZE')}}</span>
        <span class="edge-input">
          <span class="item-margin">
            <span class="text-margin">{{$t('T_WIDTH')}}:</span>
            <span class="ft_inch" v-if="currentUnit === 'T_FEET_FRACTION' || currentUnit === 'T_INCH_FRACTION'">
              <FtInput v-model="screenWidth" :unitData="currentUnit" @blur='validateData("screenWidth")'></FtInput>
            </span>
            <span v-else>
              <el-input v-model="screenWidth" @input="testDigital($event, 'screenWidth')" style="width: 100px"
                @blur='validateData("screenWidth")'
                @keyup.enter.native='validateData("screenWidth")'>
              </el-input>
              <span>{{blendingUnitLabel}}</span>
            </span>
          </span>

          <span class="screen_height_container">
            <span class="text-margin">{{$t('T_HEIGHT')}}:</span>
            <span class="ft_inch" v-if="currentUnit === 'T_FEET_FRACTION' || currentUnit === 'T_INCH_FRACTION'">
              <FtInput v-model="screenHeight" :unitData="currentUnit" @blur='validateData("screenHeight")'></FtInput>
            </span>
            <span v-else>
              <el-input v-model="screenHeight" @input="testDigital($event, 'screenHeight')" style="width: 100px"
                @blur='validateData("screenHeight")' @keyup.enter.native='validateData("screenHeight")'>
              </el-input>
              <span>{{blendingUnitLabel}}</span>
            </span>
          </span>

        </span>
      </li>

      <li class="edge_li" v-if="shapeInput!=='2'">
        <div class="edge-title">{{$t('T_INPUT_THE_SCREEN_SIZE_AND_PROJECTOR_POSITION')}}</div>
        <BlendingCurveCondition :unit="currentUnit"></BlendingCurveCondition>
      </li>

      <li class="edge_li">
        <span class="edge-title">{{$t('T_EDGE_BLENDING_CHOOSE_THE_ASPECT_RATIO_MSG')}}</span>
        <span class="edge-ratio">
          <el-select v-model="aspectRatioData">
            <el-option v-for="item in aspectRatioOptions" :key='item.key' :label='item.value' :value='item.key'>
            </el-option>
          </el-select>
        </span>
      </li>

      <li class="edge_li">
        <span class="edge-title">{{$t('T_EDGE_BLENDING_INPUT_THE_BLENDING_RANGE')}}</span>
        <span class="edge-range-input">
          <span class="text-margin">{{$t('T_EDGE_BLENDING_MIN')}}:</span>
          <el-input v-model="minRange" style="width: 100px"
            @input="testDigital($event, 'minRange')"
            @blur='checkMinRange("minRange")'
            @keyup.enter.native='checkMinRange("minRange")'>
          </el-input>
          <span v-show="blendingRangeUnit === 'Percent'">%</span>
        </span>
        <span>{{$t('T_EDGE_BLENDING_TO')}}</span>
        <span class="text-margin">{{$t('T_EDGE_BLENDING_MAX')}}:</span>
        <el-input v-model="maxRange" style="width: 100px"
            @input="testDigital($event, 'maxRange')"
            @blur='checkMaxRange("maxRange")'
            @keyup.enter.native='checkMaxRange("maxRange")'>
        </el-input>
        <span v-show="blendingRangeUnit === 'Percent'">%</span>
        <!-- <span class="switch-btn">
          <el-button plain size="mini" class="range_unit_btn" @click="changeBlendingRangeUnit" v-show="blendingRangeUnit === 'Percent'">{{$t('T_EDGE_BLENDING_CHANGE_TO_PIXEL')}}</el-button>
          <el-button plain size="mini" class="range_unit_btn" @click="changeBlendingRangeUnit" v-show="blendingRangeUnit !== 'Percent'">{{$t('T_EDGE_BLENDING_CHANGE_TO_PERCENT')}}</el-button>
        </span> -->
        <!-- <span>({{'Recommended value is ' + recomendMinRange + '%' + ' ' + 'to' + ' ' + recomendMaxRange + '%'}})</span> -->
        <span>{{recmomededs}}</span>
      </li>
      <li class="edge_li" v-if="shapeInput==='2'">
        <span class="edge-title" style="margin-right: 40px">{{$t('T_EDGE_BLENDING_INPUT_MAXIMUM_NUMBER_MSG')}}</span>
        <span>
          <span class="text-margin">{{$t('T_CURVE_ANGLE_H')}}:</span>
          <el-input v-model="numberH" @input="testDigitalPositiveInt($event, 'numberH')" style="width: 100px"
            @blur='formatNum("numberH")'
            @keyup.enter.native='formatNum("numberH")'>
          </el-input>
        </span>
        <span>
          <span class="text-margin">{{$t('T_CURVE_ANGLE_V')}}:</span>
          <el-input v-model="numberV" @input="testDigitalPositiveInt($event, 'numberV')" style="width: 100px"
            @blur='formatNum("numberV")'
            @keyup.enter.native='formatNum("numberV")'>
          </el-input>
        </span>
      </li>
      <li class="edge_li" v-if="shapeInput!=='2'">
        <span class="edge-title">{{$t('T_EDGE_BLENDING_INPUT_MAX_NUMBER_MSG')}}</span>
        <el-input v-model="projectorsValue" style="width: 100px" @input="testDigitalPositiveInt($event, 'projectorsValue')"
           @blur='formatNum("projectorsValue")'
            @keyup.enter.native='formatNum("projectorsValue")'></el-input>
      </li>
    </ul>
    <span class="unit-btn" :class="{'unit-btn-curve':shapeInput!=='2'}">
      <el-select v-model="unitData">
        <el-option v-for="item in unitDataOptions" :key='item.value' :label='$t(item.value)' :value='item.value'>
        </el-option>
      </el-select>
    </span>
    <div class="panel btn-right edge-button">
      <el-button type="button" @click="onSimulate">{{$t('T_EDGE_BLENDING_SIMULATE')}}</el-button>
      <el-button type="button" @click="loadSimulation">{{$t('T_LOAD_THE_SIMULATION_RESULT')}}</el-button>
      <input type="file" v-show="false" ref="inputFile" @change="changeLoad" />
    </div>
  </div>
</template>

<script>
import SearchProjector from '@/view/searchTabs/searchProjector'
import SearchProjectorResult from '@/view/searchTabs/searchProjectorResult'
import ComparisonLens from '@/view/searchTabs/comparisonLens'
import BlendingCurveCondition from '@/view/searchTabs/blendingCurveCondition'
import UserSaveHistory from '@/view/searchTabs/userSaveHistory'
import { EventBus } from '@/common/event-bus.js'
import FtInput from '@/components/ftInput'
import {mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data () {
    return {
      shapeOptions: [{
        value: '2',
        label: 'T_FLAT'
      },
      {
        value: '0',
        label: 'T_CURVE_CONCAVE'
      },
      {
        value: '1',
        label: 'T_CURVE_CONVEX'
      }],
      positionOptions: [{
        value: '0',
        label: 'T_POS_DESKTOP'
      },
      {
        value: '1',
        label: 'T_POS_CEILING'
      }],
      currentUnit: '',
      screenSizeUnit: 'Imperial', // Imperial' 'Metric'
      blendingRangeUnit: 'Percent',
      recomendMaxRange: '45',
      recomendMinRange: '15',
      recomendPixelMin: '0',
      recomendPixelMax: '0',
      aspectRatioData: '16:10',
      poxelW: 0,
      poxelH: 0,
      unit_label: '',
      projectorsValue: '10',
      screenWidth: '',
      screenHeight: '',
      fileList: [],
      selectedAspectRatio: ''
    }
  },

  components: {
    SearchProjector,
    SearchProjectorResult,
    ComparisonLens,
    BlendingCurveCondition,
    FtInput,
    UserSaveHistory
  },

  computed: {
    ...mapState([
      'selectedModelData',
      'selectedLensData',
      'blendingUnit',
      'blendingParam',
      'simulateTabData',
      'simulateTabSele',
      'muPoints',
      'unitDataOptions',
      'vLensShiftNow',
      'graph',
      'searchTabActive',
      'fromBlending'
    ]),
    ...mapGetters([
      'blendingUnitLabel',
      'selectedLensData_lcd_distInfo'
    ]),
    unitData: {
      get () {
        return this.blendingUnit
      },
      set (value) {
        this.SET_BLENDINGUNIT(value)
        this.changeUnitTab()
      }
    },
    position: {
      get () {
        return this.blendingParam.position
      },
      set (value) {
        this.SET_BLENDING_POSITION(value)
        EventBus.$emit('changePosition')
      }
    },
    shapeInput: {
      get () {
        return this.blendingParam.shapeShow
      },
      set (value) {
        this.SET_BLENDING_SCREEN_SHAPESHOW(value)
      }
    },
    recmomededs () {
      if (this.blendingRangeUnit === 'Percent') {
        return this.$t('T_EDGE_BLENDING_RECOMMEDED_VALUE_PERCENT')
      } else {
        return this.$t('T_EDGE_BLENDING_RECOMMEDED_VALUE_PIXCEL', {size1: this.recomendPixelMin, size2: this.recomendPixelMax})
      }
    },
    screen_width () {
      return this.blendingParam.screenSize.width
    },
    screen_height () {
      return this.blendingParam.screenSize.height
    },
    minRange: {
      get () {
        return this.blendingParam.range.min
      },
      set (value) {
        this.SET_BLENDING_RANGE_MIN(value)
      }
    },
    maxRange: {
      get () {
        return this.blendingParam.range.max
      },
      set (value) {
        this.SET_BLENDING_RANGE_MAX(value)
      }
    },
    numberH: {
      get () {
        return this.blendingParam.number.h
      },
      set (value) {
        this.SET_BLENDING_NUMBER_H(value)
      }
    },
    numberV: {
      get () {
        return this.blendingParam.number.v
      },
      set (value) {
        this.SET_BLENDING_NUMBER_V(value)
      }
    },
    // <backup>
    // aspectRatioData: {
    //   get () {
    //     return this.blendingParam.ratio
    //   },
    //   set (value) {
    //     this.SET_BLENDING_RATIO(value)
    //   }
    // },

    selectedLensOptions () {
      return this.selectedLensData_lcd_distInfo.map((item) => {
        return {
          key: item.ratio,
          value: item.ratio
        }
      })
    },
    aspectRatioOptions () {
      if (this.shapeInput === '2' && this.selectedModelData.modelSeries !== 'Kuwait-DS') {
        let optionArr = this.selectedLensOptions.map(item => {
          let ratioNum = item.value.split(':')
          let value = ratioNum[1] + ':' + ratioNum[0]
          return {
            key: value,
            value: value
          }
        })
        return this.selectedLensOptions.concat(optionArr)
      }
      return this.selectedLensOptions
    }
    // currentUnit () {
    //   return this.screenSizeUnit === 'Imperial' ? 'T_MILLIMETER_MM' : 'T_INCH_FRACTION'
    // }
  },
  watch: {
    'blendingParam.screenSize.width': {
      handler (val, oldVal) {
        this.screenWidth = this.$commonJs.changeUnit(val, this.currentUnit, false, true)
      }
    },
    'blendingParam.screenSize.height': {
      handler (val, oldVal) {
        this.screenHeight = this.$commonJs.changeUnit(val, this.currentUnit, false, true)
      }
    },
    selectedModelData (val, oldVal) {
      // this.aspectRatioData = this.selectedLensData.lcd.aspectRatio
      this.aspectRatioData = this.blendingParam.ratio
      // 計算実行した後に機種を変更した場合、変更後の機種も同じアスペクトを持っていたら維持する。
      // 変更後の機種が同じアスペクト比を持っていない場合、再計算がされないため、その機種のデフォルトアスペクトに変更する
      // 計算実行前に機種を変更した場合、アスペクトはその機種のデフォルトアスペクトに変更する
      if (oldVal.name !== val.name) {
        if (this.selectedAspectRatio) {
          let findRatio = this.aspectRatioOptions.find(item => {
            return item.key === this.selectedAspectRatio
          })
          if (!findRatio) {
            this.aspectRatioData = this.selectedLensData.lcd.aspectRatio
          } else {
            this.aspectRatioData = this.selectedAspectRatio
          }
        } else {
          this.aspectRatioData = this.selectedLensData.lcd.aspectRatio
        }
      }

      this.shapeOptions.forEach(item => {
        item.disabled = false
      })
      if (val.edgeBlendFlat && !val.edgeBlendCurve) {
        this.shapeOptions[2].disabled = true
        this.shapeOptions[1].disabled = true
        this.shapeOptions[0].disabled = false
      } else if (val.edgeBlendFlat && val.edgeBlendCurve) {
        this.shapeOptions[2].disabled = false
        this.shapeOptions[1].disabled = false
        this.shapeOptions[0].disabled = false
      } else if (!val.edgeBlendFlat && val.edgeBlendCurve) {
        this.shapeOptions[0].disabled = true
        this.SET_BLENDING_SCREEN_SHAPESHOW(0)
      }
    },
    aspectRatioData (val, oldVal) {
      EventBus.$emit('currentRatioChange', val)
    },
    shapeInput (val, oldVal) {
      if (oldVal === '2' && val !== '2') {
        let findRatio = this.selectedLensOptions.find(item => {
          return item.key === this.blendingParam.ratio
        })
        if (findRatio === undefined || this.aspectRatioData !== findRatio.key) {
          // this.aspectRatioData = this.selectedLensData.lcd.aspectRatio
          this.aspectRatioData = this.aspectRatioOptions[0].key
          this.SET_BLENDING_RATIO(this.aspectRatioData)
        }
      }
    },
    searchTabActive (val, oldVal) {
      // if (val === 'Blending' && oldVal === 'Search' && this.fromBlending) {
      //   this.SET_FROMBLENDING(false)
      // }
    },
    aspectRatioOptions (val, oldVal) {
      // 镜头发生改变时，aspectRatioOptions的内容会发生改变。
      // aspectRatioOptions(pulldown)里面，无実行后的宽高比的话，改成默认的宽高比
      if (this.selectedAspectRatio) {
        let findRatio = this.aspectRatioOptions.find(item => {
          return item.key === this.selectedAspectRatio
        })
        if (!findRatio) {
          this.aspectRatioData = this.selectedLensData.lcd.aspectRatio
        } else {
          this.aspectRatioData = this.selectedAspectRatio
        }
      } else {
        this.aspectRatioData = this.selectedLensData.lcd.aspectRatio
      }
    }
  },

  methods: {
    ...mapMutations([
      'SET_BLENDING_SIMULATETABDATA',
      'SET_BLENDING_SIMULATETABSELE',
      'SET_MUPOINTS',
      'SET_BLENDING_SCREEN_SHAPESHOW',
      'SET_BLENDING_SCREEN_SHAPE',
      'SET_BLENDING_SCREEN_WIDHT',
      'SET_BLENDING_SCREEN_HEIGHT',
      'SET_BLENDING_RATIO',
      'SET_BLENDING_POSITION',
      'SET_BLENDING_SELENSDATA',
      'SET_BLENDING_VLENSSHIFT',
      'SET_BLENDING_HLENSSHIFT',
      'SET_BLENDING_VHLENSSHIFT',
      'SET_BLENDING_VLENSSHIFTNOW',
      'SET_BLENDING_RANGE_MIN',
      'SET_BLENDING_RANGE_MAX',
      'SET_BLENDING_LENSSHIFTV',
      'SET_BLENDINGUNIT',
      'SET_SIMULATESWITCHFLAG',
      'SET_BLENDING_NUMBER_H',
      'SET_BLENDING_NUMBER_V',
      'SELECTEDMODELDATA',
      'SELECTEDLENSDATA',
      'SET_BLENDING_RADIUS',
      'SET_BLENDING_SCREENHEIGHT',
      'SET_BLENDING_LENSHEIGHT',
      'SET_BLENDING_LENSHEIGHTRATE_MIN',
      'SET_BLENDING_LENSHEIGHTRATE_MAX',
      'SET_BLENDING_ANGLE',
      'SET_BLENDING',
      'SET_FROMBLENDING',
      'MATCHINGLENSID',
      'SET_LIMITVALUE',
      'SET_BLENDINGEDGEPOINTS_INIT',
      'SET_CAMERA_ASSIST_SIZE_MIN',
      'SET_CAMERA_ASSIST_SIZE_MAX'
    ]),
    changeUnitTab () {
      let widthValue = this.$commonJs.changeUnit(this.screenWidth, this.currentUnit, true)
      this.screenWidth = this.$commonJs.changeUnit(widthValue, this.blendingUnit, false)

      let heightValue = this.$commonJs.changeUnit(this.screenHeight, this.currentUnit, true)
      this.screenHeight = this.$commonJs.changeUnit(heightValue, this.blendingUnit, false)

      this.currentUnit = this.blendingUnit
    },
    // changeScreenSizeUnit () {
    //   this.screenSizeUnit = this.screenSizeUnit === 'Imperial' ? 'Metric' : 'Imperial'
    //   if (this.screenSizeUnit === 'Imperial') {
    //     this.currentUnit = 'T_MILLIMETER_MM'
    //     this.unit_label = 'mm'
    //   } else {
    //     this.currentUnit = 'T_INCH_FRACTION'
    //     this.unit_label = 'inch'
    //   }
    //   this.screenWidth = this.$commonJs.changeUnit(this.screen_width, this.currentUnit, false, true)
    //   this.screenHeight = this.$commonJs.changeUnit(this.screen_height, this.currentUnit, false, true)
    // },
    changeBlendingRangeUnit () {
      this.blendingRangeUnit = this.blendingRangeUnit === 'Percent' ? 'Pixel' : 'Percent'
      let re = this.$commonJs.findResolutionByKey(this.selectedModelData.resolution)
      if (re.value.indexOf('x') !== -1) {
        this.poxelW = re.value.split('x')[0].trim()
        this.poxelH = re.value.split('x')[1].trim()
        if (this.blendingRangeUnit === 'Percent') {
          this.recomendMinRange = (this.minRange / this.poxelW * 100).toFixed(0)
          this.recomendMaxRange = (this.maxRange / this.poxelW * 100).toFixed(0)
        } else {
          this.recomendMinRange = (this.poxelW * this.minRange / 100).toFixed(0)
          this.recomendMaxRange = (this.poxelW * this.maxRange / 100).toFixed(0)
          this.recomendPixelMin = (this.poxelW * 15 / 100).toFixed(0)
          this.recomendPixelMax = (this.poxelW * 45 / 100).toFixed(0)
        }
      }
      this.SET_BLENDING_RANGE_MIN(this.recomendMinRange)
      this.SET_BLENDING_RANGE_MAX(this.recomendMaxRange)
    },
    setPoxelW () {
      let re = this.$commonJs.findResolutionByKey(this.selectedModelData.resolution)
      this.poxelW = re.value.split('x')[0].trim()
      this.poxelH = re.value.split('x')[1].trim()
    },
    testDigital (e, key) {
      e = e.replace(/[^0-9|.]/ig, '')
      let n = (this[key].split('.') || []).length - 1
      if (n > 1) {
        e = ''
      }
      this[key] = e
    },
    testDigitalPositiveInt (e, key) {
      e = e.replace(/[^(0+)|[^\d]+/g, '')
      this[key] = e || ''
    },
    formatNum (key) {
      if (this.projectorsValue === '') {

      } else {
        this[key] *= 1
      }
    },
    checkMinRange (key) {
      if (isNaN(this[key])) this[key] = '0'
      let value = this[key] * 1
      if (value > this.maxRange * 1) {
        value = this.maxRange * 1
      }
      this[key] = value
    },
    checkMaxRange (key) {
      if (isNaN(this[key])) this[key] = '0'
      let value = this[key] * 1
      if (this.blendingRangeUnit === 'Percent' && value > 100) {
        value = 100
      }
      if (this.blendingRangeUnit !== 'Percent' && value > this.poxelW) {
        value = this.poxelW
      }
      if (value < this.minRange * 1) {
        value = this.minRange * 1
      }
      this[key] = value
    },
    checkNumberV (key) {
      let value = this[key] * 1
      if (value >= 3) {
        value = 3
      } else if (value <= 1) {
        value = 1
      }
      this[key] = value
    },
    setLensShift () {
      let lensShiftVal = 0
      let data = this.selectedLensData
      let defaultRatio = data.lcd.aspectRatio
      let defaultDistInfo = this.$commonJs.findSpecInfoByRatio(defaultRatio, data)
      let res = 0
      // 为超短焦设置默认vlens shift
      if (this.selectedModelData.type === 1 && data.lcd.lensShiftRange.v.min === 0 && data.lcd.lensShiftRange.v.max === 0) {
        let initSize = this.$commonViewJs.getScreenXYByScreenSize(defaultDistInfo.screenSize.w.min, defaultRatio)
        let v1b = defaultDistInfo.screenSize.w.min * defaultDistInfo.v1b.w.a + defaultDistInfo.v1b.w.b
        res = (initSize.calY / 2 + v1b - data.mu) / initSize.calY
      } else if (this.$commonViewJs.isLongLensExistsLens()) {
        let initSize = this.$commonViewJs.getScreenXYByScreenSize(defaultDistInfo.screenSize.w.min, defaultRatio)
        if (!initSize) return
        res = (defaultDistInfo.wv.wv2 * defaultDistInfo.screenSize.w.min - initSize.calY / 2) / initSize.calY
      } else if (data.id && data.id.indexOf('LX') > -1) {
        res = data.lcd.lensShiftRange.v.min
      }
      lensShiftVal = this.blendingParam.position === '0' ? res * 100 : res * -100
      return lensShiftVal
    },
    onSimulate () {
      let mixMin = 0
      let mixMax = 0
      this.setPoxelW()
      if (this.blendingRangeUnit === 'Percent') {
        mixMin = this.minRange / 100
        mixMax = this.maxRange / 100
      } else {
        mixMin = this.minRange / this.poxelW
        mixMax = this.maxRange / this.poxelW
      }
      // 保存执行按钮押下时的 宽高比
      this.selectedAspectRatio = this.aspectRatioData
      // 生成blending参数
      this.SET_BLENDING_RATIO(this.aspectRatioData)
      this.SET_BLENDING_SCREEN_WIDHT(this.$commonJs.changeUnit(this.screenWidth, this.currentUnit, true))
      this.SET_BLENDING_SCREEN_HEIGHT(this.$commonJs.changeUnit(this.screenHeight, this.currentUnit, true))
      this.SET_BLENDING_SCREEN_SHAPE(this.shapeInput)
      this.SET_BLENDING_SELENSDATA(this.selectedLensData)
      this.SET_BLENDING_VLENSSHIFT(this.graph.vLensShift)
      this.SET_BLENDING_HLENSSHIFT(this.graph.hLensShift)
      this.SET_BLENDING_VHLENSSHIFT(this.graph.vhLensShift)
      if (this.blendingParam.screenShape === '2') {
        let val = this.setLensShift()
        this.SET_BLENDING_VLENSSHIFTNOW(val)
      } else {
        // v2.1曲面多台保持原有逻辑不变
        this.SET_BLENDING_VLENSSHIFTNOW(this.vLensShiftNow)
        this.SET_LIMITVALUE(0)
        this.SET_BLENDINGEDGEPOINTS_INIT([])
      }
      let ratio = this.blendingParam.ratio.split(':')
      let rationVal = Number(ratio[0]) < Number(ratio[1]) ? `${Number(ratio[1])}:${Number(ratio[0])}` : this.blendingParam.ratio
      let perPjScreenSizeRange = this.$commonJs.findSpecInfoByRatio(rationVal, this.selectedLensData).screenSize.w

      let parm = {}
      parm.blendingRangeUnit = this.blendingRangeUnit
      parm.poxelW = Number(this.poxelW)
      parm.poxelH = Number(this.poxelH)
      parm.ratio = ratio
      parm.ratioDefault = this.selectedLensData.lcd.aspectRatio.split(':')
      EventBus.$emit('simulationChange', parm)
      if (this.shapeInput !== '2') {
        EventBus.$emit('changeCurveParm')
      }
      // shapeInput为2，表示平面多台
      if (this.shapeInput === '2') {
        this.SET_SIMULATESWITCHFLAG(0)
        // 计算表格数据
        let data = this.$commonBlendingJs.getMultipleComb(this.blendingParam.screenSize.width, this.blendingParam.screenSize.height, mixMin, mixMax, Number(this.numberH), Number(this.numberV), this.blendingParam.ratio, perPjScreenSizeRange)
        if (data.length === 0) {
          this.SET_BLENDING_SIMULATETABDATA([])
          this.SET_MUPOINTS([])
          EventBus.$emit('onClearCanvas')
          return
        }
        this.SET_BLENDING_SIMULATETABDATA(data)
        let p = this.$commonBlendingJs.getInitMultiplePosi(data[0].h, data[0].v, data[0].screenW, data[0].screenH, data[0].mixRateH, data[0].mixRateV, data[0].disMin)
        this.SET_MUPOINTS(p)
        this.SET_BLENDING_SIMULATETABSELE(0)
        let flag = this.$commonViewJs.blendingIsReAspactRatio()
        if (flag) {
          this.SET_BLENDING_LENSHEIGHT(data[0].screenW - p[0].x)
        } else {
          this.SET_BLENDING_LENSHEIGHT(data[0].screenH - p[0].z)
        }
      } else if (this.shapeInput === '0') {
        // shapeInput为0，表示凹面多台
        this.SET_SIMULATESWITCHFLAG(1)
        let h = this.blendingParam.screenHeight
        let scSize = this.$commonViewJs.getScreenSizeByCalY(h, this.blendingParam.ratio).size
        let disMin = this.$commonViewJs.calScreensizeToDistanceBlendingWide(scSize)
        // disMin = 765.5
        let disMax = this.$commonViewJs.calScreensizeToDistanceBlendingTele(scSize)
        let ang = (this.$commonJs.getDegreesByRadian(this.blendingParam.angle)).toFixed(2)
        let radius = this.blendingParam.radius
        // let radius = 1500
        let data = this.$commonBlendingJs.getCurvedMultipleCombAo(h, radius, ang, mixMin, mixMax, this.blendingParam.ratio, disMin, disMax, perPjScreenSizeRange, this.projectorsValue)
        if (data.length === 0) {
          this.SET_BLENDING_SIMULATETABDATA([])
          this.SET_MUPOINTS([])
          EventBus.$emit('onClearCanvas')
          EventBus.$emit('onClearCanvasOne')
          return
        }
        this.SET_BLENDING_SIMULATETABDATA(data)
        let p = []
        p = this.$commonBlendingJs.getCurvedMultiplePoints(radius, data[0].arcLen, data[0].mixRateH, data[0].total, data[0].disMin, '0', data[0].angle)
        // console.log(data)
        // console.log(p)
        this.SET_MUPOINTS(p)
        this.SET_BLENDING_SIMULATETABSELE(0)
        let CameraAssistSizeMin = this.getDataCommon('CameraAssistSizeMin')
        let CameraAssistSizeMax = this.getDataCommon('CameraAssistSizeMax')
        this.SET_CAMERA_ASSIST_SIZE_MIN(CameraAssistSizeMin)
        this.SET_CAMERA_ASSIST_SIZE_MAX(CameraAssistSizeMax)
        // EventBus.$emit('onCurveGraphChanged')
      } else if (this.shapeInput === '1') {
        // shapeInput为1，表示凸面多台
        this.SET_SIMULATESWITCHFLAG(1)
        let h = this.blendingParam.screenHeight
        let scSize = this.$commonViewJs.getScreenSizeByCalY(h, this.blendingParam.ratio).size
        let disMin = this.$commonViewJs.calScreensizeToDistanceBlendingWide(scSize)
        // disMin = 480
        let disMax = this.$commonViewJs.calScreensizeToDistanceBlendingTele(scSize)
        let ang = (this.$commonJs.getDegreesByRadian(this.blendingParam.angle)).toFixed(2)
        let radius = this.blendingParam.radius
        let data = this.$commonBlendingJs.getCurvedMultipleCombTu(h, radius, ang, mixMin, mixMax, this.blendingParam.ratio, disMin, disMax, perPjScreenSizeRange, this.projectorsValue)
        if (data.length === 0) {
          this.SET_BLENDING_SIMULATETABDATA([])
          this.SET_MUPOINTS([])
          EventBus.$emit('onClearCanvas')
          EventBus.$emit('onClearCanvasOne')
          return
        }
        this.SET_BLENDING_SIMULATETABDATA(data)
        let p = []
        p = this.$commonBlendingJs.getCurvedMultiplePoints(radius, data[0].arcLen, data[0].mixRateH, data[0].total, data[0].disMin, '1', data[0].angle)
        this.SET_MUPOINTS(p)
        this.SET_BLENDING_SIMULATETABSELE(0)
        this.SET_CAMERA_ASSIST_SIZE_MIN(this.getDataCommon('CameraAssistSizeMin'))
        this.SET_CAMERA_ASSIST_SIZE_MAX(this.getDataCommon('CameraAssistSizeMax'))
      }
      // 为每台曲面多台的投影仪单独赋值z及lensShift
      if (this.shapeInput !== '2') {
        let seleData = this.simulateTabData[this.simulateTabSele]
        let initScreen = this.$commonViewJs.getInitScreenXyFromDist(this.simulateTabData[this.simulateTabSele].disMin)
        let h = initScreen.calY
        var vLens2 = Number((seleData.screenH - this.blendingParam.lensHeight - seleData.screenH / 2) / h)
        vLens2 = this.blendingParam.position === '1' ? (vLens2 * -1) : vLens2
        this.SET_BLENDING_LENSSHIFTV(vLens2 * 100)
        let z = seleData.screenH / 2 - (seleData.screenH - this.blendingParam.lensHeight)
        for (let i = 0; i < this.muPoints.length; i++) {
          this.muPoints[i].z = z
          if (this.blendingParam.position === '0') {
            this.muPoints[i].vLensShift = vLens2 * 100
            this.SET_BLENDING_VLENSSHIFTNOW(vLens2 * 100)
          } else {
            this.muPoints[i].vLensShift = -vLens2 * 100
            this.SET_BLENDING_VLENSSHIFTNOW(-vLens2 * 100)
          }
        }
        this.SET_MUPOINTS(this.muPoints)
      }
      // EventBus.$emit('blendCalc', s)
      // EventBus.$emit('existSide')
    },
    getDataCommon (key) {
      let cameraAssistInfo
      let lensExchange = this.selectedModelData.lensExchange
      let code = this.selectedModelData.code
      if (lensExchange) {
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            cameraAssistInfo = this.Brightness.optionLens[i][key]
          }
        }
      } else {
        for (let i = 0; i < this.ProjectorLensSpec.length; i++) {
          if (this.ProjectorLensSpec[i].code === code) {
            cameraAssistInfo = this.ProjectorLensSpec[i][key]
          }
        }
      }
      return cameraAssistInfo
    },
    validateData (key) {
      if (!(this.currentUnit === 'T_FEET_FRACTION' || this.currentUnit === 'T_INCH_FRACTION') && (isNaN(this[key]) || this[key] === '')) this[key] = '0'
      let value = this.$commonJs.changeUnit(this[key], this.currentUnit, true)
      this[key] = this.$commonJs.changeUnit(value, this.currentUnit, false)
    },
    // changeMutation (key, mutationKey) {
    //   let value = this.$commonJs.changeUnit(this[key], this.currentUnit, true)
    //   // this[key] = this.$commonJs.changeUnit(value, this.currentUnit, false)
    //   this[mutationKey](value)
    // },
    init () {
      this.currentUnit = this.blendingUnit
      this.screenWidth = this.$commonJs.changeUnit(this.screen_width, this.graph.unit, false, true) // TODO
      this.screenHeight = this.$commonJs.changeUnit(this.screen_height, this.graph.unit, false, true) // TODO
      this.unit_label = this.blendingUnitLabel
      this.aspectRatioData = this.aspectRatioOptions[0].key
    },

    loadSimulation () {
      this.$refs.inputFile.click()
    },

    changeLoad () {
      var reader = new FileReader()
      reader.readAsText(this.$refs.inputFile.files[0], 'UTF-8')
      reader.onload = (evt) => {
        let data = JSON.parse(evt.target.result)
        this.SELECTEDMODELDATA(data.model)
        this.SELECTEDLENSDATA(data.lens)
        this.MATCHINGLENSID(data.matchingLensID)
        this.SET_BLENDING(data.blendingParam)
        this.SET_BLENDING_SIMULATETABDATA(data.simulateTabData)
        this.SET_BLENDING_SIMULATETABSELE(data.simulateTabSele)
        this.SET_MUPOINTS(data.muPoints)
        this.SET_BLENDINGUNIT(data.blendingUnit)
        this.$nextTick(() => {
          this.currentUnit = this.blendingUnit
          this.screenWidth = this.$commonJs.changeUnit(this.screen_width, this.currentUnit, false, true) // TODO
          this.screenHeight = this.$commonJs.changeUnit(this.screen_height, this.currentUnit, false, true) // TODO
          this.aspectRatioData = data.blendingParam.ratio
          if (data.blendingParam.shapeShow === '0') {
            this.SET_SIMULATESWITCHFLAG(1)
          } else if (data.blendingParam.shapeShow === '1') {
            this.SET_SIMULATESWITCHFLAG(1)
          } else {
            this.SET_SIMULATESWITCHFLAG(0)
          }
        })
        this.$refs.inputFile.value = ''
      }
    }
  },

  mounted () {
    this.init()
  }
}

</script>
<style scoped>
.edge_ul {
  border-right: 2px solid #bdbdbd;
  /* padding: 20px; */
  list-style-type: decimal;
}
.edge_li {
  margin: 0 20px;
  padding: 10px 0px;
  list-style-type: decimal;
  list-style-position:inside
}
.edge_li span{
  font-size: 14px
}
.edge_ul .edge_li:nth-child(n+3) {
  border-bottom: 1px solid #bdbdbd;
}
.seach-content{
  background-color: #f0f0f0;
  padding: 20px
}
.edge-button{
  border-bottom: 0!important;
}
.edge-title {
  min-width: 20%;
  display:inline-block;
  font-size: 14px

}
.switch-btn{
  float: right;
}
.unit-btn{
  right: 22px;
  position: absolute;
  top: 456px;
}
.unit-btn-curve{
  top: 470px !important;
}
.screen_height_container{
  margin-left: 10px
}
.range_unit_btn{
  width: auto;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/searchTabs/edgeBlending.vue